import * as stylex from '@stylexjs/stylex'
import { colors } from '../tokens/colors.stylex'

export const hmColors = {
  brand: '#C80032',
  primary50: '#FFFAF9',
  primary100: '#FFEEE8',
  primary200: '#F8CCC0',
  primary300: '#F0AA9A',
  primary400: '#E98776',
  primary500: '#E16554',
  primary600: '#DA4234',
  primary700: '#B72821',
  primary800: '#931412',
  primary900: '#700708',

  secondary50: '#FFFAF9',
  secondary100: '#FFEEE8',
  secondary200: '#F8CCC0',
  secondary300: '#F0AA9A',
  secondary400: '#E98776',
  secondary500: '#E16554',
  secondary600: '#DA4234',
  secondary700: '#B72821',
  secondary800: '#931412',
  secondary900: '#700708',

  tertiary50: '#F7F6F6',
  tertiary100: '#D7D3D0',
  tertiary200: '#D7D3D0',
  tertiary300: '#D5D3D1',
  tertiary400: '#988C80',
  tertiary500: '#766B61',
  tertiary600: '#544A43',
  tertiary700: '#AB5338',
  tertiary800: '#AB5338',
  tertiary900: '#6C1C0C',
}

export const colorTheme = stylex.createTheme(colors, hmColors)
